import { BigNumber } from 'bignumber.js';
import { ethers } from 'ethers';
import { get } from 'lodash';
import { getAbiFromTokenAddress } from './ethereumApi';
import constants from './trexConstants';
import { DVD } from '@tokenyico/trex-sdk';
import { getAddress } from 'viem';
import {
  prepareWriteContract,
  writeContract,
  waitForTransaction,
  getNetwork,
  getWalletClient,
} from '@wagmi/core';

export function sendTransfer({ tokenAddress, toAddress, amount, decimals }) {
  return new Promise(async (resolve, reject) => {
    try {
      const contractAbi = await getAbiFromTokenAddress();

      const sanitized = {
        toAddress: getAddress(toAddress),
        // fromAddress: getAddress(fromAddress),
        tokenAddress: getAddress(tokenAddress),
        amount: new BigNumber(amount)
          .multipliedBy(Math.pow(10, decimals))
          .decimalPlaces(0)
          .toString(10),
        abi: JSON.parse(contractAbi),
      };
      const contractConfig = {
        address: sanitized.tokenAddress,
        abi: sanitized.abi,
        functionName: 'transfer',
      };
      const { request } = await prepareWriteContract({
        ...contractConfig,
        args: [sanitized.toAddress, sanitized.amount],
      });
      const { hash } = await writeContract(request);
      const data = await waitForTransaction({ hash });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

// decreaseAllowance, increaseAllowance, approve
export function sendMethod({ method, tokenAddress, toAddress, amount }) {
  return new Promise(async (resolve, reject) => {
    try {
      const contractAbi = await getAbiFromTokenAddress();

      const sanitized = {
        toAddress: getAddress(toAddress),
        tokenAddress: getAddress(tokenAddress),
        amount,
        abi: JSON.parse(contractAbi),
      };

      const contractConfig = {
        address: sanitized.tokenAddress,
        abi: sanitized.abi,
        functionName: method,
      };
      const { request } = await prepareWriteContract({
        ...contractConfig,
        args: [sanitized.toAddress, sanitized.amount],
      });
      const { hash } = await writeContract(request);
      const data = await waitForTransaction({ hash });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

async function getDVDInstance({ network }) {
  const { chain } = getNetwork();
  const { transport } = await getWalletClient();
  const netWorkConfigForProvider = {
    chainId: chain.id,
    name: chain.name,
    ensAddress: chain.contracts?.ensRegistry?.address,
  };
  const dvdContractAddress = get(constants.dvdTransferManagersContracts, network);
  const provider = new ethers.providers.Web3Provider(transport, netWorkConfigForProvider);
  const dvd = await DVD.at(dvdContractAddress, provider);
  dvd.providerOrSigner = provider.getSigner();
  return dvd;
}

export async function sendDvdInitiate({ fromAddress, network, data }) {
  try {
    const sanitized = {
      fromAddress: getAddress(fromAddress),
      senderToken: getAddress(data.senderToken),
      senderAmount: data.senderAmount, //new BigNumber(amount).multipliedBy(10 ** decimals).toFixed(0),
      counterpartToken: getAddress(data.counterpartToken),
      counterpartAmount: data.counterpartAmount, //new BigNumber(amount).multipliedBy(10 ** decimals).toFixed(0),
      counterpart: getAddress(data.counterpart),
    };

    const dvd = await getDVDInstance({ network });

    const transaction = await dvd.initiate({
      counterpart: sanitized.counterpart,
      counterpartAmount: sanitized.counterpartAmount,
      counterpartToken: sanitized.counterpartToken,
      senderAmount: sanitized.senderAmount,
      senderToken: sanitized.senderToken,
    });

    const receipt = await transaction.wait();
    const transferId = DVD.getTransferIdFromReceipt(receipt);
    return transferId;
  } catch (error) {
    throw error;
  }
}

export async function sendDvdApprove({ network, data }) {
  try {
    const dvd = await getDVDInstance({ network });
    const transaction = await dvd.take(data.transferId);
    const receipt = await transaction.wait();
    return receipt;
  } catch (error) {
    throw error;
  }
}

export async function sendDvdCancel({ network, data }) {
  try {
    const dvd = await getDVDInstance({ network });
    const transaction = await dvd.cancel(data.transferId);
    const receipt = await transaction.wait();
    return receipt;
  } catch (error) {
    throw error;
  }
}
